document.addEventListener('DOMContentLoaded', function () {
    var originalBtn = document.querySelector('product-form button[type="submit"]');
    var stickyBar = document.getElementById('StickyAtcBar');
    var stickyBtn = document.getElementById('StickyAtcButton');
    var footer = document.querySelector('footer');

    if (!originalBtn || !stickyBar || !stickyBtn) return;

    document.body.appendChild(stickyBar);

    stickyBtn.addEventListener('click', function () {
      originalBtn.click();
    });

    var btnPastView = false;
    var footerVisible = false;

    function updateVisibility() {
      stickyBar.classList.toggle('is-visible', btnPastView && !footerVisible);
    }

    var btnObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        btnPastView = !entry.isIntersecting;
        updateVisibility();
      });
    }, { threshold: 0 });
    btnObserver.observe(originalBtn);

    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          footerVisible = entry.isIntersecting;
          updateVisibility();
        });
      }, { threshold: 0 });
      footerObserver.observe(footer);
    }
  });